/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderFileVo
 */
export interface OrderFileVo {
    /**
     * 主键id
     * @type {number}
     * @memberof OrderFileVo
     */
    id?: number;
    /**
     * 文件url
     * @type {string}
     * @memberof OrderFileVo
     */
    fileUrl?: string;
    /**
     * 原始文件名
     * @type {string}
     * @memberof OrderFileVo
     */
    fileName?: string;
}

/**
 * Check if a given object implements the OrderFileVo interface.
 */
export function instanceOfOrderFileVo(value: object): value is OrderFileVo {
    return true;
}

export function OrderFileVoFromJSON(json: any): OrderFileVo {
    return OrderFileVoFromJSONTyped(json, false);
}

export function OrderFileVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderFileVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
    };
}

export function OrderFileVoToJSON(json: any): OrderFileVo {
    return OrderFileVoToJSONTyped(json, false);
}

export function OrderFileVoToJSONTyped(value?: OrderFileVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileUrl': value['fileUrl'],
        'fileName': value['fileName'],
    };
}

